import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  firstName: "",
  lastName: "",
  password: "",
  sex: "",
  phone: "",
  province: "",
  cityTown: "",
  street: "",
  zipCode: "",
  refCode: "",
  country: "",
  isEighteen: false,
  hasAgreedToMarketing: false,
  hasAgreedToTermsAndConditions: false,
  occupation: "",
  usage: "",
};

export const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setREmail: (state, action) => {
      state.email = action.payload;
    },
    setRfirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setRlastName: (state, action) => {
      state.lastName = action.payload;
    },
    setRpassword: (state, action) => {
      state.password = action.payload;
    },

    setRsex: (state, action) => {
      state.sex = action.payload;
    },
    setRphone: (state, action) => {
      state.phone = action.payload;
    },
    setRprovince: (state, action) => {
      state.province = action.payload;
    },
    setRcityTown: (state, action) => {
      state.cityTown = action.payload;
    },
    setRstreet: (state, action) => {
      state.street = action.payload;
    },
    setRzipCode: (state, action) => {
      state.zipCode = action.payload;
    },
    setRrefCode: (state, action) => {
      state.refCode = action.payload;
    },
    setRcountry: (state, action) => {
      state.country = action.payload;
    },
    setRisEighteen: (state, action) => {
      state.isEighteen = action.payload;
    },
    setRoccupation: (state, action) => {
      state.occupation = action.payload;
    },
    setRusage: (state, action) => {
      state.usage = action.payload;
    },
    setRhasAgreedToMarketing: (state, action) => {
      state.hasAgreedToMarketing = action.payload;
    },
    setRhasAgreedToTermsAndConditions: (state, action) => {
      state.hasAgreedToTermsAndConditions = action.payload;
    },
    unsetAccount: (state) => {
      state.email = "";
      state.firstName = "";
      state.lastName = "";
      state.password = "";
      state.sex = "";
      state.phone = "";
      state.province = "";
      state.cityTown = "";
      state.street = "";
      state.zipCode = "";
      state.refCode = "";
      state.country = "";
      state.isEighteen = false;
      state.occupation = "";
      state.usage = "";
      state.hasAgreedToMarketing = false;
      state.hasAgreedToTermsAndConditions = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setREmail,
  setRfirstName,
  setRlastName,
  setRpassword,
  setRsex,
  setRphone,
  setRprovince,
  setRcityTown,
  setRstreet,
  setRzipCode,
  setRrefCode,
  unsetAccount,
  setRcountry,
  setRisEighteen,
  setRoccupation,
  setRusage,
  setRhasAgreedToMarketing,
  setRhasAgreedToTermsAndConditions,
} = registrationSlice.actions;

export default registrationSlice.reducer;
